import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'mc-project-files-access-error-message',
  templateUrl: './project-files-access-error-message.component.html',
  styleUrls: ['./project-files-access-error-message.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectFilesAccessErrorMessageComponent {
  @Input() accessErrorMessage: string;
}
